import { useState, useCallback } from 'react';
import { CLASSIC_MATCHES } from '../data/matches';
function shuffle(a){const b=[...a];for(let i=b.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[b[i],b[j]]=[b[j],b[i]];}return b;}
export default function ScorePredictor({onBack,best,setBest}){
  const TOTAL=8;
  const [phase,setPhase]=useState('home');
  const [qs,setQs]=useState([]);
  const [qi,setQi]=useState(0);
  const [h,setH]=useState('');
  const [a,setA]=useState('');
  const [submitted,setSubmitted]=useState(false);
  const [score,setScore]=useState(0);
  const [lastPts,setLastPts]=useState(0);
  const start=useCallback(()=>{
    setQs(shuffle(CLASSIC_MATCHES).slice(0,TOTAL));setQi(0);setH('');setA('');setSubmitted(false);setScore(0);setPhase('play');
  },[]);
  const submit=useCallback(()=>{
    if(submitted||h===''||a==='')return;
    const m=qs[qi];const hg=parseInt(h),ag=parseInt(a);
    const exact=hg===m.homeScore&&ag===m.awayScore;
    const cr=(hg>ag&&m.homeScore>m.awayScore)||(hg<ag&&m.homeScore<m.awayScore)||(hg===ag&&m.homeScore===m.awayScore);
    const pts=exact?3:cr?1:0;
    setLastPts(pts);setSubmitted(true);
    const ns=score+pts;setScore(ns);if(ns>best)setBest(ns);
  },[submitted,h,a,qs,qi,score,best,setBest]);
  const next=useCallback(()=>{
    if(qi+1>=TOTAL){setPhase('over');return;}
    setQi(qi+1);setH('');setA('');setSubmitted(false);
  },[qi]);
  const m=qs[qi],pct=(qi/TOTAL)*100;
  const grade=score>=22?'Match Analyst':score>=16?'Football Brain':score>=10?'Decent Memory':score>=5?'Lucky Guesses':'Were You Watching?';
  const btnStyle={padding:'11px 34px',border:'none',borderRadius:10,background:'linear-gradient(135deg,#fb923c,#c2410c)',color:'#fff',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.25rem',letterSpacing:'0.1em',cursor:'pointer',marginTop:8};
  return(<div className="layer" style={{display:'flex',flexDirection:'column',minHeight:'100vh'}}>
    <div className="g-hdr">
      <button className="g-back" onClick={onBack}>← Menu</button>
      <div className="g-title" style={{color:'#fb923c'}}>SCORE PREDICTOR</div>
      {phase==='play'&&<div className="g-pills">
        <div className="g-pill" style={{borderColor:'#c2410c'}}><span className="g-plbl">Score</span><span className="g-pval">{score}</span></div>
        <div className="g-pill"><span className="g-plbl">Best</span><span className="g-pval">{best}</span></div>
      </div>}
    </div>
    {phase==='home'&&<div className="game-home"><div className="game-inner">
      <div className="game-eye" style={{color:'#fb923c',border:'1px solid #c2410c'}}>Classic World Cup Matches</div>
      <h1 className="game-big" style={{color:'#fb923c'}}>SCORE PREDICTOR</h1>
      <p className="game-desc">Guess the final score of classic World Cup matches.<br/><strong>3 pts</strong> exact · <strong>1 pt</strong> correct result.</p>
      {best>0&&<p className="game-best" style={{color:'#fb923c'}}>Best: {best}</p>}
      <button style={btnStyle} onClick={start}>KICK OFF</button>
    </div></div>}
    {phase==='over'&&<div className="game-home"><div className="over-card">
      <div className="over-tag" style={{color:'#fb923c',border:'1px solid #c2410c'}}>FINAL WHISTLE</div>
      <h1 className="over-h1">{grade}</h1>
      <div className="over-stats">
        <div className="over-stat"><span className="over-num" style={{color:'#fb923c'}}>{score}</span><span className="over-lbl">Points</span></div>
        <div className="over-div"/>
        <div className="over-stat"><span className="over-num" style={{color:'#fb923c'}}>{best}</span><span className="over-lbl">Best</span></div>
      </div>
      <button style={{...btnStyle,marginTop:0}} onClick={start}>PLAY AGAIN</button>
    </div></div>}
    {phase==='play'&&m&&<div className="game-body">
      <div className="prog-row"><div className="prog-bar"><div style={{height:'100%',background:'linear-gradient(90deg,#fb923c,#c2410c)',borderRadius:2,width:pct+'%',transition:'width 0.4s'}}/></div><span className="prog-pct">Match {qi+1}/{TOTAL}</span></div>
      <div className="match-card">
        <div style={{fontSize:'0.52rem',letterSpacing:'0.18em',color:'#8ba3cc',textTransform:'uppercase',marginBottom:10}}>{m.stage} · {m.year}</div>
        <div className="match-teams">
          <div className="match-team"><div className="match-flag">{m.homeFlag}</div><div className="match-name">{m.home}</div></div>
          <div className="match-vs">VS</div>
          <div className="match-team"><div className="match-flag">{m.awayFlag}</div><div className="match-name">{m.away}</div></div>
        </div>
        <div className="match-meta">{m.label}</div>
      </div>
      {!submitted?<>
        <p style={{fontSize:'0.8rem',color:'#8ba3cc',textAlign:'center'}}>What was the final score?</p>
        <div className="score-inputs">
          <input className="score-input" type="number" min="0" max="20" value={h} onChange={e=>setH(e.target.value)} placeholder="0"/>
          <span className="score-dash">-</span>
          <input className="score-input" type="number" min="0" max="20" value={a} onChange={e=>setA(e.target.value)} placeholder="0"/>
        </div>
        <button className="btn-gold" onClick={submit} disabled={h===''||a===''}>SUBMIT</button>
      </>:<>
        <div className={'result-box '+(lastPts>0?'ok':'no')}>
          <div className={'result-head '+(lastPts>0?'ok':'no')}>
            {lastPts===3?'Exact score! +3 pts':lastPts===1?'Correct result! +1 pt':'Wrong result'}
          </div>
          <div className="result-detail">Score: {m.home} {m.homeScore}–{m.awayScore} {m.away}</div>
        </div>
        <div className="game-actions">
          <span className="remaining">{qi+1<TOTAL?(TOTAL-qi-1)+' left':'Last!'}</span>
          <button style={{padding:'9px 20px',border:'none',borderRadius:9,cursor:'pointer',background:'linear-gradient(135deg,#fb923c,#c2410c)',color:'#fff',fontFamily:"'Bebas Neue',sans-serif",fontSize:'1.08rem',letterSpacing:'0.08em'}} onClick={next}>{qi+1>=TOTAL?'Results →':'Next →'}</button>
        </div>
      </>}
    </div>}
  </div>);
}
